// extracted by mini-css-extract-plugin
module.exports = {"button":"BurgerButton_button__1ooo0","line":"BurgerButton_line__ouF6s","cross":"BurgerButton_cross__2MyC_"};